import { dollarFormatter, percentageBarFormatter } from "../../gridFormatters";

export const cloudSumamryDefs = [
  {
    "field": "resource_name",
    "headerName": "Resource Name"
  },
  {
    "field": "device_type_description",
    "headerName": "Cloud Provider"
  },
  {
    "field": "resource_group",
    "headerName": "Resource Group"
  },
  {
    "field": "resource_location",
    "headerName": "Resource Location"
  },
	{
		"field": "total_cost",
		"headerName": "Cost this Month",
		"cellRenderer": dollarFormatter,
    "type": "numericColumn",
	},
	{
		"field": "cpu_used_pct",
		"headerName": "% CPU",
		"cellRenderer": percentageBarFormatter,
    "type": "numericColumn",
	},
	{
		"field": "memory_used_pct",
		"headerName": "% Memory",
		"cellRenderer": percentageBarFormatter,
    "type": "numericColumn",
	},
	{
		"field": "disk_used_pct",
		"headerName": "% Disk",
		"cellRenderer": percentageBarFormatter,
    "type": "numericColumn",
	},
];